import instance from './testing.instance';

export const getTokenSocket = () => instance.get(`/socket/get-token/`);

export const urlRealtimeLastVersion = 'wss://powermate-socket.powermeter.com.ar/ws?token='




